module.exports = __webpack_public_path__ + "media/images/default/pages/homepage/patient_recommends/img_avatar_09-97ca4a777251b844ac31879f903ec287.png";